import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@material-ui/core/styles';
import UserService from '../../../services/UserService';
import TextField from "@material-ui/core/TextField";
import Phone from "../../tools/Phone";
import BanqueDeCvService from "../../../services/BanqueCvService";
import Alert from "@material-ui/lab/Alert";
import { useNavigate } from "react-router-dom";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
    Grid,
    Paper,
    Button,
    FormControl,
    Select,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio,
    Link,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Tooltip,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { AlertTitle } from '@material-ui/lab';
import { CircularProgress } from "@material-ui/core";
import Spacer from '../../../components/Spacer';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { 
    Divider, 
    InputAdornment 
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import PhoneIcon from '@material-ui/icons/Phone';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ContractService from '../../../services/ContractService';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: 'visible', // Permet le scroll
        [theme.breakpoints.down('sm')]: {
            overflow: 'visible',
        }
    },
    container: {
        width: '100%',
        overflow: 'visible', // Permet le scroll
        [theme.breakpoints.down('sm')]: {
            overflow: 'visible',
            padding: '8px 4px',
        }
    },
    welcom: {
        fontSize: '4.5rem',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '2.5rem',
        }
    },
    avatar: {
        justifyContent: "center"
    },
    userAccount: {
        margin: "20px",
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            margin: "8px 0",
            padding: '0 4px',
        }
    },
    userAccountTitle: {
        borderBottom: "1px solid",
    },
    userAccountTitleBtn: {
        padding: "20px",
        [theme.breakpoints.down('sm')]: {
            padding: "10px",
        }
    },
    userPasswordTitle: {
        borderBottom: "1px solid",
    },
    userPasswordBtn: {
        padding: "20px",
    },
    userAccountChangePassword: {
        margin: "20px",
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            margin: "8px 0",
            padding: '0 4px',
            width: '100%',
        }
    },
    userAccordionFooter: {
        marginLeft: "20px",
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            marginLeft: "4px",
            marginRight: "4px",
            width: '100%',
        }
    },
    tableContainer: {
        marginTop: theme.spacing(2),
        borderRadius: '8px',
        overflowX: 'auto', // Permet le scroll horizontal du tableau
        overflowY: 'visible',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(1),
            borderRadius: '4px',
        }
    },
    tableHeader: {
        backgroundColor: '#1976d2',
        '& th': {
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '11px',
                padding: '6px 4px',
                whiteSpace: 'nowrap',
            }
        }
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#f5f5f5',
        },
        '&:hover': {
            backgroundColor: '#e3f2fd',
        }
    },
    contractButton: {
        textTransform: 'none',
        fontSize: '12px',
        minWidth: 'auto',
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px',
            padding: '4px 6px',
            minWidth: '60px',
        }
    },
    statusChip: {
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            fontSize: '9px',
            height: '20px',
            '& .MuiChip-label': {
                padding: '0 6px',
            }
        }
    },
    statusActive: {
        backgroundColor: '#4caf50',
        color: 'white',
    },
    statusExpired: {
        backgroundColor: '#f44336',
        color: 'white',
    },
    statusPending: {
        backgroundColor: '#ff9800',
        color: 'white',
    },
    uploadButton: {
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(0.5),
        }
    },
    infoCard: {
        padding: '24px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        margin: '20px 0',
        width: '100%',
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            padding: '12px 8px',
            margin: '8px 0',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        }
    },
    sectionTitle: {
        marginBottom: '24px',
        color: '#1976d2',
        fontWeight: '600',
        borderLeft: '4px solid #1976d2',
        paddingLeft: '12px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
            marginBottom: '12px',
            paddingLeft: '8px',
        }
    },
    actionButton: {
        fontWeight: 600,
        textTransform: 'none',
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginTop: '4px',
            fontSize: '12px',
            padding: '6px 12px',
        }
    },
    mobileTableWrapper: {
        width: '100%',
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            margin: '0 -4px',
            padding: '0 4px',
        }
    },
    fileUploadButton: {
        height: '40px',
        textTransform: 'none',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            height: '36px',
            fontSize: '11px',
            padding: '4px 8px',
            '& .MuiButton-startIcon': {
                marginRight: '4px',
            }
        }
    },
    mobileAlert: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
            padding: '6px 12px',
            '& .MuiAlert-message': {
                padding: '4px 0',
            },
            '& .MuiAlert-icon': {
                padding: '4px 0',
            }
        }
    },
    form: {
        width: '100%',
        overflow: 'visible',
    },
    gridContainer: {
        width: '100%',
        margin: 0,
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            padding: '0 4px',
        }
    },
    gridItem: {
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            padding: '4px !important',
        }
    },
    accordionDetails: {
        padding: theme.spacing(2),
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            padding: '8px 4px',
            overflow: 'visible',
        }
    },
    textField: {
        '& .MuiInputBase-root': {
            [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
            }
        }
    },
    selectField: {
        [theme.breakpoints.down('sm')]: {
            '& .MuiSelect-select': {
                fontSize: '14px',
                padding: '10px 32px 10px 12px',
            }
        }
    }
}));

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
        margin: '2px 0',
        overflow: 'visible',
    }
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(0.5),
        }
    },
    [theme.breakpoints.down('sm')]: {
        minHeight: '44px !important',
        padding: '0 8px',
        '& .MuiAccordionSummary-content': {
            margin: '8px 0',
        }
    }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
        padding: '8px 4px',
        overflow: 'visible',
    }
}));

export const INTERNAL_FILE_STORAGE_PATH = process.env.REACT_APP_API_URL.replace("api", "uploads/cv/");

export default function DetailAccordions(props) {
    const navigate = useNavigate();
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const userInfo = props.userInfo;
    const message = props.message;
    const sexe = props.sexe;
    const isDisable = props.isDisable;
    const form = props.form;
    const isEmptyNewPass = props.isEmptyNewPass;
    const isEmptyNewPassMessage = props.isEmptyNewPassMessage;
    const isEmptyConfirmPass = props.isEmptyConfirmPass;
    const isEmptyConfirmPassMessage = props.isEmptyConfirmPassMessage;
    const IsCompatibleNewAndConfirmPassword = props.IsCompatibleNewAndConfirmPassword;
    const IsCompatibleNewAndConfirmPasswordMessage = props.IsCompatibleNewAndConfirmPasswordMessage;

    const handleChangePassword = props.handleChangePassword;
    const handleClickBtnSave = props.handleClickBtnSave;
    const handleClickBtnSavePassword = props.handleClickBtnSavePassword;
    const handleFocusConfirmPassword = props.handleFocusConfirmPassword;
    const handleFocusNewPassword = props.handleFocusNewPassword;
    const handleClickBtnSaveDelegateAuthority = props.handleClickBtnSaveDelegateAuthority;
    const handleClickBtnModifDelegateAuthority = props.handleClickBtnModifDelegateAuthority;
    const handleClickBtnCancelDelegateAuthority = props.handleClickBtnCancelDelegateAuthority;
    const handleChange = props.handleChangePanel;

    const dir = props.dir;
    const service = props.service;
    const users = props.users;
    const handleChangeDirection = props.handleChangeDirection;
    const handleSelect = props.handleSelect;
    const handleChangeService = props.handleChangeService;
    const handleChangeUsers = props.handleChangeUsers;

    const idDir = props.idDir;
    const idservice = props.idservice;
    const iduser = props.iduser;
    const idDelegate = props.idDelegate;
    const showAddDelegateForm = props.showAddDelegateForm;
    const showDelegateDetail = props.showDelegateDetail;
    const expanded = props.expanded;
    const loading = props.loading;
    const userData = localStorage.getItem('USER'); 
    const idDelegateDetail = props.idDelegateDetail;
    const [detailaffectation, setDetailsaffectation] = useState([]);
    
    const [uploadingContract, setUploadingContract] = useState({});

    const [additionalInfoForm, setAdditionalInfoForm] = useState({
        orangeNumber: '',
        parentalNumber: '',
        cin: '',
        assuranceFile: null,
        diplomeFile: null,
        contratFile: null,
        assuranceFileName: '',
        diplomeFileName: '',
        contratFileName: ''
    });

    const [additionalInfoLoading, setAdditionalInfoLoading] = useState(false);
    const [additionalInfoSuccess, setAdditionalInfoSuccess] = useState('');
    const [additionalInfoError, setAdditionalInfoError] = useState('');

    useEffect(() => {
        if (userInfo && userInfo.isSTG === "1") {
            loadExistingAdditionalInfo();
            getDetailsaffectaion();
        }
    }, [userInfo]);

    const loadExistingAdditionalInfo = async () => {
        try {
            const userId = getLocalStorageUser();
            if (userId) {
                const response = await UserService.getAdditionalInfo(userId);
                if (response && response.data) {
                    setAdditionalInfoForm({
                        orangeNumber: response.data.orange_number || '',
                        parentalNumber: response.data.parental_number || '',
                        cin: response.data.cin || '',
                        assuranceFile: null,
                        diplomeFile: null,
                        contratFile: null,
                        assuranceFileName: response.data.assurance_file_name || '',
                        diplomeFileName: response.data.diplome_file_name || '',
                        contratFileName: response.data.contrat_file_name || ''
                    });
                }
            }
        } catch (error) {
            console.error("Erreur lors du chargement des infos:", error);
        }
    };

    const getDetailsaffectaion = async () => {
        try {
            const userId = getLocalStorageUser();
            if (userId) {
                const response = await ContractService.getdetailsaffectation(userId);
                if (response && response.data) {
                    setDetailsaffectation(response.data);
                }
            }
        } catch (error) {
            setDetailsaffectation([]);
        }
    };

    const getLocalStorageUser = () => {
        return localStorage.getItem('USER');
    };

    const handleClick = () => {
        const user = getLocalStorageUser();
        if (user) {
            navigate(`/information_famille/add/${user}`);
        } else {
            console.log("Aucun utilisateur trouvé dans le localStorage");
        }
    };

    const handleAdditionalInfoChange = (field) => (event) => {
        setAdditionalInfoForm({
            ...additionalInfoForm,
            [field]: event.target.value
        });
        setAdditionalInfoError('');
        setAdditionalInfoSuccess('');
    };

    const handleFileChange = (field, fileFieldName) => (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 25 * 1024 * 1024) {
                setAdditionalInfoError(`Le fichier ${file.name} dépasse la taille maximale de 25Mo`);
                return;
            }
            setAdditionalInfoForm({
                ...additionalInfoForm,
                [field]: file,
                [fileFieldName]: file.name
            });
            setAdditionalInfoError('');
            setAdditionalInfoSuccess('');
        }
    };

    const handleContractFileChange = (userAffectationId, currentFileName) => (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 25 * 1024 * 1024) {
                setAdditionalInfoError(`Le fichier ${file.name} dépasse la taille maximale de 25Mo`);
                return;
            }
            
            setUploadingContract(prev => ({ ...prev, [userAffectationId]: true }));
            
            const formData = new FormData();
            formData.append('user_affectation_id', userAffectationId);
            formData.append('contrat_file', file);
            
            UserService.saveContract(formData)
                .then((response) => {
                    if (response && response.status) {
                        setAdditionalInfoSuccess("Contrat uploadé avec succès");
                        getDetailsaffectaion();
                        setTimeout(() => setAdditionalInfoSuccess(''), 3000);
                    } else {
                        setAdditionalInfoError(response?.message || "Erreur lors de l'upload du contrat");
                    }
                })
                .catch((error) => {
                    console.error("Erreur lors de l'upload:", error);
                    setAdditionalInfoError("Une erreur est survenue lors de l'upload du contrat");
                })
                .finally(() => {
                    setUploadingContract(prev => ({ ...prev, [userAffectationId]: false }));
                });
        }
    };

    const handleSaveAdditionalInfo = async () => {
        setAdditionalInfoLoading(true);
        setAdditionalInfoError('');
        setAdditionalInfoSuccess('');

        try {
            const userId = getLocalStorageUser();
            if (!userId) {
                setAdditionalInfoError("Utilisateur non identifié");
                return;
            }

            const formData = new FormData();
            formData.append('user_id', userId);
            formData.append('orange_number', additionalInfoForm.orangeNumber);
            formData.append('parental_number', additionalInfoForm.parentalNumber);
            formData.append('cin', additionalInfoForm.cin);
            
            if (additionalInfoForm.assuranceFile) {
                formData.append('assurance_file', additionalInfoForm.assuranceFile);
            }
            if (additionalInfoForm.diplomeFile) {
                formData.append('diplome_file', additionalInfoForm.diplomeFile);
            }

            const response = await UserService.saveAdditionalInfo(formData);
            
            if (response && response.status) {
                setAdditionalInfoSuccess("Informations enregistrées avec succès");
                loadExistingAdditionalInfo();
                setTimeout(() => {
                    setAdditionalInfoSuccess('');
                }, 3000);
            } else {
                setAdditionalInfoError(response.message || "Erreur lors de l'enregistrement");
            }
        } catch (error) {
            console.error("Erreur lors de l'enregistrement:", error);
            setAdditionalInfoError("Une erreur est survenue lors de l'enregistrement");
        } finally {
            setAdditionalInfoLoading(false);
        }
    };

    const handleShowSelectedCV = (iduser) => {
        try {
            BanqueDeCvService.showCvByUserId(iduser).then((result) => {
                if (result.data) {
                    window.open(INTERNAL_FILE_STORAGE_PATH + result.data, '_blank');
                } else {
                    alert("Pas de CV dans le systeme");
                }
            });
        } catch (err) {
            console.log(err);
        }
    };

    const [detailsCv, setDetailscv] = useState({});

    const handleDownloadFile = (fileName) => {
        if (!fileName) {
            console.error('Nom de fichier non fourni');
            return;
        }

        const fileUrl = `${process.env.REACT_APP_API_URL_FILEPGI}stagiaires/${fileName}`;
        
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank'; 
        link.rel = 'noopener noreferrer'; 
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getContractStatus = (dateFin) => {
        if (!dateFin) return { label: 'En cours', color: 'statusActive' };
        const endDate = new Date(dateFin);
        const today = new Date();
        if (endDate < today) {
            return { label: 'Expiré', color: 'statusExpired' };
        }
        return { label: 'Actif', color: 'statusActive' };
    };

    useEffect(() => {
        UserService.getCV().then((results) => {
            if (results && results.status) {
                setDetailscv(results.data);
            }
        });
    }, [props]);

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                {/* Panel 1: Information personnel */}
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                        <Typography variant={isMobile ? "body2" : "body1"}>Information personnel</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}>
                        <div className={classes.infoCard}>
                            <Typography variant={isMobile ? "subtitle1" : "h6"} className={classes.sectionTitle}>
                                Informations personnelles
                            </Typography>
                            
                            <Grid container spacing={isMobile ? 1 : 3} className={classes.userAccount}>
                                {/* Nom */}
                                <Grid item xs={12} sm={6} className={classes.gridItem}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Nom"
                                        variant="outlined"
                                        value={userInfo.userLastName?.toUpperCase() || ''}
                                        name="last_name"
                                        disabled={isDisable}
                                        className={classes.textField}
                                        InputProps={{
                                            style: { backgroundColor: isDisable ? '#f5f5f5' : '#ffffff' }
                                        }}
                                    />
                                </Grid>

                                {/* Prénom */}
                                <Grid item xs={12} sm={6} className={classes.gridItem}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Prénom"
                                        variant="outlined"
                                        value={userInfo.userFirstName || ''}
                                        name="first_name"
                                        disabled={isDisable}
                                        className={classes.textField}
                                        InputProps={{
                                            style: { backgroundColor: isDisable ? '#f5f5f5' : '#ffffff' }
                                        }}
                                    />
                                </Grid>

                                {/* Téléphone */}
                                <Grid item xs={12} sm={6} className={classes.gridItem}>
                                    <Phone 
                                        x1={12} 
                                        x2={12} 
                                        name="telephone" 
                                        value={userInfo.userphone} 
                                        disabled={isDisable}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Email */}
                                <Grid item xs={12} sm={6} className={classes.gridItem}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Email"
                                        variant="outlined"
                                        type="email"
                                        value={userInfo.userEmail || ''}
                                        name="email"
                                        disabled={isDisable}
                                        className={classes.textField}
                                        InputProps={{
                                            style: { backgroundColor: isDisable ? '#f5f5f5' : '#ffffff' }
                                        }}
                                    />
                                </Grid>

                                {/* Sexe */}
                                <Grid item xs={12} className={classes.gridItem}>
                                    <FormControl component="fieldset">
                                        <Typography variant={isMobile ? "caption" : "subtitle2"} style={{ marginBottom: '8px', color: '#666' }}>
                                            Sexe
                                        </Typography>
                                        <RadioGroup
                                            aria-label="sex"
                                            name="sex"
                                            row
                                            value={userInfo.userSex}
                                        >
                                            {sexe.map((row) => (
                                                <FormControlLabel
                                                    key={row.sex_id}
                                                    disabled={isDisable}
                                                    value={row.sex_id}
                                                    control={<Radio color="primary" size={isMobile ? "small" : "medium"} />}
                                                    label={row.name}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>

                                {/* Section pour les utilisateurs normaux */}
                                {userInfo.isSTG === "0" && (
                                    <Grid item xs={12} className={classes.gridItem}>
                                        <Divider style={{ margin: '16px 0' }} />
                                        <Grid container spacing={isMobile ? 1 : 2} alignItems="center">
                                            <Grid item xs={12} sm={4}>
                                                <Typography variant={isMobile ? "caption" : "subtitle2"} style={{ color: '#666' }}>
                                                    Informations familiales:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={8}>
                                                <Button 
                                                    variant="contained" 
                                                    color="primary" 
                                                    className={classes.actionButton}
                                                    onClick={handleClick}
                                                    startIcon={<AddIcon />}
                                                    fullWidth={isMobile}
                                                >
                                                    Ajouter des informations famille
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                                
                                {/* Section pour les stagiaires */}
                                {userInfo.isSTG === "1" && (
                                    <Grid item xs={12} className={classes.gridItem}>
                                        <Divider style={{ margin: '16px 0' }} />
                                        <Typography variant={isMobile ? "subtitle1" : "subtitle1"} style={{ 
                                            marginBottom: '20px', 
                                            color: '#1976d2',
                                            fontWeight: '500'
                                        }}>
                                            Informations complémentaires
                                        </Typography>
                                        
                                        {additionalInfoSuccess && (
                                            <Alert severity="success" className={classes.mobileAlert} style={{ marginBottom: '16px' }}>
                                                {additionalInfoSuccess}
                                            </Alert>
                                        )}
                                        
                                        {additionalInfoError && (
                                            <Alert severity="error" className={classes.mobileAlert} style={{ marginBottom: '16px' }}>
                                                {additionalInfoError}
                                            </Alert>
                                        )}
                                        
                                        <Grid container spacing={isMobile ? 1 : 3}>
                                            <Grid item xs={12} sm={6} className={classes.gridItem}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Numéro Orange"
                                                    variant="outlined"
                                                    placeholder="Entrez le numéro Orange"
                                                    value={additionalInfoForm.orangeNumber}
                                                    onChange={handleAdditionalInfoChange('orangeNumber')}
                                                    className={classes.textField}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <PhoneIcon color="action" />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={6} className={classes.gridItem}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Numéro Parental"
                                                    variant="outlined"
                                                    placeholder="Entrez le numéro parental"
                                                    value={additionalInfoForm.parentalNumber}
                                                    onChange={handleAdditionalInfoChange('parentalNumber')}
                                                    className={classes.textField}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <ContactPhoneIcon color="action" />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={6} className={classes.gridItem}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="CIN"
                                                    variant="outlined"
                                                    placeholder="CIN"
                                                    value={additionalInfoForm.cin}
                                                    onChange={handleAdditionalInfoChange('cin')}
                                                    className={classes.textField}
                                                />
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={6} className={classes.gridItem}>
                                                <Button
                                                    variant="outlined"
                                                    component="label"
                                                    fullWidth
                                                    className={classes.fileUploadButton}
                                                    startIcon={<AttachFileIcon />}
                                                >
                                                    {additionalInfoForm.assuranceFileName || "Attestation assurance (Max 25Mo)"}
                                                    <input 
                                                        type="file" 
                                                        hidden 
                                                        accept=".pdf,.doc,.docx" 
                                                        onChange={handleFileChange('assuranceFile', 'assuranceFileName')}
                                                    />
                                                </Button>
                                                {additionalInfoForm.assuranceFileName && (
                                                    <Typography variant="caption" style={{ marginTop: '4px', display: 'block' }}>
                                                        Fichier sélectionné: 
                                                        <Button 
                                                            size="small"
                                                            onClick={() => handleDownloadFile(additionalInfoForm.assuranceFileName)}
                                                            startIcon={<FileDownloadIcon sx={{ color: 'green' }} />}
                                                            style={{ marginLeft: '8px' }}
                                                        >
                                                            {additionalInfoForm.assuranceFileName}
                                                        </Button>
                                                    </Typography>
                                                )}
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={6} className={classes.gridItem}>
                                                <Button
                                                    variant="outlined"
                                                    component="label"
                                                    fullWidth
                                                    className={classes.fileUploadButton}
                                                    startIcon={<AttachFileIcon />}
                                                >
                                                    {additionalInfoForm.diplomeFileName || "Diplôme (Max 25Mo)"}
                                                    <input 
                                                        type="file" 
                                                        hidden 
                                                        accept=".pdf,.doc,.docx" 
                                                        onChange={handleFileChange('diplomeFile', 'diplomeFileName')}
                                                    />
                                                </Button>
                                                {additionalInfoForm.diplomeFileName && (
                                                    <Typography variant="caption" style={{ marginTop: '4px', display: 'block' }}>
                                                        Fichier sélectionné: 
                                                        <Button 
                                                            size="small"
                                                            onClick={() => handleDownloadFile(additionalInfoForm.diplomeFileName)}
                                                            startIcon={<FileDownloadIcon sx={{ color: 'green' }} />}
                                                            style={{ marginLeft: '8px' }}
                                                        >
                                                            {additionalInfoForm.diplomeFileName}
                                                        </Button>
                                                    </Typography>
                                                )}
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={2} className={classes.gridItem}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleSaveAdditionalInfo}
                                                    disabled={additionalInfoLoading}
                                                    className={classes.actionButton}
                                                    fullWidth={isMobile}
                                                    startIcon={additionalInfoLoading ? <CircularProgress size={isMobile ? 16 : 20} /> : null}
                                                >
                                                    {additionalInfoLoading ? "Chargement..." : "ENREGISTRER"}
                                                </Button>
                                            </Grid>

                                            {/* Tableau des affectations */}
                                            <Grid item xs={12} className={classes.gridItem}>
                                                <Typography variant={isMobile ? "subtitle2" : "subtitle2"} style={{ 
                                                    marginTop: '16px', 
                                                    marginBottom: '12px',
                                                    color: '#1976d2',
                                                    fontWeight: '500'
                                                }}>
                                                    Historique des affectations
                                                </Typography>
                                                
                                                <div className={classes.mobileTableWrapper}>
                                                    <TableContainer component={Paper} className={classes.tableContainer}>
                                                        <Table size={isMobile ? "small" : "small"}>
                                                            <TableHead className={classes.tableHeader}>
                                                                <TableRow>
                                                                    <TableCell>N°</TableCell>
                                                                    <TableCell>Direction</TableCell>
                                                                    <TableCell>Service</TableCell>
                                                                    <TableCell>Fonction</TableCell>
                                                                    {!isMobile && <TableCell>Financement</TableCell>}
                                                                    <TableCell>Début</TableCell>
                                                                    <TableCell>Fin</TableCell>
                                                                    <TableCell>Statut</TableCell>
                                                                    <TableCell>Contrat</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {detailaffectation && detailaffectation.length > 0 ? (
                                                                    detailaffectation.map((element, index) => {
                                                                        const status = getContractStatus(element.date_fin);
                                                                        const isUploading = uploadingContract[element.user_affectation_id];
                                                                        
                                                                        return (
                                                                            <TableRow key={element.user_affectation_id || index} className={classes.tableRow}>
                                                                                <TableCell>
                                                                                    <Chip 
                                                                                        label={index+1}
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell>{element.direction_name || '-'}</TableCell>
                                                                                <TableCell>{element.service_name || '-'}</TableCell>
                                                                                <TableCell>{element.function_name || '-'}</TableCell>
                                                                                {!isMobile && <TableCell>{element.funding_code || '-'}</TableCell>}
                                                                                <TableCell>
                                                                                    {element.date_prise || '-'}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {element.date_fin || '-'}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Chip 
                                                                                        label={status.label}
                                                                                        size="small"
                                                                                        className={`${classes.statusChip} ${classes[status.color]}`}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {element.file_contract ? (
                                                                                        <Tooltip title="Voir le contrat">
                                                                                            <Button
                                                                                                size="small"
                                                                                                variant="outlined"
                                                                                                color="primary"
                                                                                                onClick={() => handleDownloadFile(element.file_contract)}
                                                                                                startIcon={<VisibilityIcon />}
                                                                                                className={classes.contractButton}
                                                                                            >
                                                                                                {isMobile ? "Voir" : "Voir contrat"}
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                    ) : (
                                                                                        <Tooltip title="Ajouter le contrat pour cette affectation">
                                                                                            <Button
                                                                                                variant="outlined"
                                                                                                component="label"
                                                                                                size="small"
                                                                                                color="secondary"
                                                                                                startIcon={isUploading ? <CircularProgress size={isMobile ? 12 : 16} /> : <CloudUploadIcon />}
                                                                                                className={classes.contractButton}
                                                                                                disabled={isUploading}
                                                                                            >
                                                                                                {isUploading ? "..." : isMobile ? "Ajouter" : "Ajouter contrat"}
                                                                                                <input 
                                                                                                    type="file" 
                                                                                                    hidden 
                                                                                                    accept=".pdf,.doc,.docx" 
                                                                                                    onChange={handleContractFileChange(element.user_affectation_id, element.file_contract)}
                                                                                                />
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <TableRow>
                                                                        <TableCell colSpan={isMobile ? 8 : 9} align="center">
                                                                            <Typography variant="body2" color="textSecondary">
                                                                                Aucune affectation trouvée
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                    </AccordionDetails>
                </Accordion>
                
                {/* Panel 2: Mot de passe */}
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                        <Typography>Mot de passe</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}>
                        <form className={classes.form}>
                            <Grid container spacing={isMobile ? 1 : 2} className={classes.userAccountChangePassword}>
                                <Grid item xs={isMobile ? 12 : 4} className={classes.gridItem}>
                                    <label>Nouveau mot de passe*:</label>
                                </Grid>
                                <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                    <TextField
                                        fullWidth
                                        id="outlined-basic"
                                        size="small"
                                        label="Nouveau mot de passe"
                                        variant="outlined"
                                        name="newpassword"
                                        type="password"
                                        onChange={handleChangePassword}
                                        onFocus={handleFocusNewPassword}
                                        className={classes.textField}
                                    />
                                    {isEmptyNewPass && (
                                        <Alert severity="error" className={classes.mobileAlert}>{isEmptyNewPassMessage}</Alert>
                                    )}
                                </Grid>
                                <Grid item xs={4} className={classes.gridItem}></Grid>
                                <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                    <p style={{ fontSize: isMobile ? '12px' : '14px' }}>
                                        <h4 style={{ fontSize: isMobile ? '13px' : '16px' }}>Niveau de sécurité du mot de passe :</h4>
                                        Utilisez au moins 8 caractères contenant des lettres en capitales et en minuscules, des nombres et des caractères spéciaux.
                                    </p>
                                </Grid>
                                <Grid item xs={isMobile ? 12 : 4} className={classes.gridItem}>
                                    <label>Confirmation mot de passe*:</label>
                                </Grid>
                                <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                    <TextField
                                        fullWidth
                                        id="outlined-basic"
                                        size="small"
                                        label="Confirmation mot de passe"
                                        variant="outlined"
                                        type="password"
                                        name="confirmpassword"
                                        onChange={handleChangePassword}
                                        onFocus={handleFocusConfirmPassword}
                                        className={classes.textField}
                                    />
                                    {isEmptyConfirmPass && (
                                        <Alert severity="error" className={classes.mobileAlert}>{isEmptyConfirmPassMessage}</Alert>
                                    )}
                                    {!IsCompatibleNewAndConfirmPassword && (
                                        <Alert severity="error" className={classes.mobileAlert}>{IsCompatibleNewAndConfirmPasswordMessage}</Alert>
                                    )}
                                </Grid>
                                <Grid item xs={isMobile ? 6 : 9} className={classes.gridItem}></Grid>
                                <Grid item xs={isMobile ? 6 : 3} className={classes.gridItem}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleClickBtnSavePassword}
                                        style={{ fontWeight: 600 }}
                                        fullWidth={isMobile}
                                    >
                                        ENREGISTRER
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </AccordionDetails>
                </Accordion>
                
                {/* Panel 3: Délégation de pouvoir */}
                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                        <Typography>Délégation de pouvoir</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}>
                        {showDelegateDetail &&
                            <>
                                <Alert
                                    className={classes.mobileAlert}
                                    action={
                                        <div style={{ display: isMobile ? 'flex' : 'block', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '4px' : '0' }}>
                                            <Button color="inherit" size={isMobile ? "small" : "small"}
                                                onClick={handleClickBtnModifDelegateAuthority}>
                                                Modifier
                                            </Button>
                                            <Button color="inherit" size={isMobile ? "small" : "small"} style={{color: "red"}}
                                                onClick={handleClickBtnCancelDelegateAuthority}>
                                                Annuler
                                            </Button>
                                        </div>
                                    }
                                >
                                    <AlertTitle>Configuration</AlertTitle>
                                    Votre compte est maintenant délégé à <strong>{idDelegate.user_delegate_name}</strong>
                                </Alert>
                            </>
                        }
                        {showAddDelegateForm &&
                            <Grid container spacing={isMobile ? 1 : 2} className={classes.userAccountChangePassword}>
                                <Grid item xs={isMobile ? 12 : 4} className={classes.gridItem}>
                                    <label>Direction:</label>
                                </Grid>
                                <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <Select 
                                            labelId="demo-simple-select-outlined-label" 
                                            id="demo-simple-select-outlined" 
                                            value={idDir} 
                                            name="direction_id" 
                                            onChange={handleChangeDirection} 
                                            onFocus={handleSelect}
                                            className={classes.selectField}
                                        >
                                            {dir.map((row) => (
                                                <MenuItem key={row.direction_id} value={row.direction_id}>{row.name}  ( {row.code} )</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={isMobile ? 12 : 4} className={classes.gridItem}>
                                    <label>Utilisateur:</label>
                                </Grid>
                                <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                    <Autocomplete
                                        onChange={handleChangeUsers}
                                        options={users}
                                        defaultValue={iduser}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                className={classes.textField}
                                                InputProps={{ ...params.InputProps, type: "search" }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={isMobile ? 6 : 9} className={classes.gridItem}></Grid>
                                <Grid item xs={isMobile ? 6 : 3} className={classes.gridItem}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleClickBtnSaveDelegateAuthority}
                                        style={{ fontWeight: 600 }}
                                        fullWidth={isMobile}
                                    >
                                        {loading ? <CircularProgress size={isMobile ? 20 : 24} /> : "ENREGISTRER"}
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </AccordionDetails>
                </Accordion>
                
                {/* Panel 4: Mise à jour du CV */}
                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                        <Typography>Mise à jour du CV</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}> 
                        <div style={{ width: '100%', overflow: 'visible' }}>
                            <Grid item xs={12} className={classes.userAccordionFooter}>                    
                                <Alert icon={<WarningAmberIcon fontSize="inherit" />} severity="info" className={classes.mobileAlert}>
                                    Veuillez vérifier que les informations concernant la Direction, le Service et la Fonction sont correctes.
                                </Alert>
                            </Grid>
                            <Grid container spacing={isMobile ? 1 : 2} className={classes.userAccount}>
                                {detailsCv !== null ? (
                                    <>                         
                                        <Grid item xs={isMobile ? 12 : 3} className={classes.gridItem}>
                                            <label>Direction :</label>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label=""
                                                variant="outlined"
                                                value={detailsCv.direction_name}
                                                name="direction_name"
                                                disabled={isDisable}
                                                className={classes.textField}
                                            />
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 3} className={classes.gridItem}>
                                            <label>Service :</label>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label=""
                                                variant="outlined"
                                                value={detailsCv.service_name}
                                                name="service_name"
                                                disabled={isDisable}
                                                className={classes.textField}
                                            />
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 3} className={classes.gridItem}>
                                            <label>Fonction :</label>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label=""
                                                variant="outlined"
                                                value={detailsCv.function_name}
                                                name="function_name"
                                                disabled={isDisable}
                                                className={classes.textField}
                                            />
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 3} className={classes.gridItem}>
                                            <label>Nom :</label>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label=""
                                                variant="outlined"
                                                value={detailsCv.nom}
                                                name="user_name"
                                                disabled={isDisable}
                                                className={classes.textField}
                                            />
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 3} className={classes.gridItem}>
                                            <label>CV:</label>
                                        </Grid>
                                        <Grid item xs={isMobile ? 12 : 8} className={classes.gridItem}>
                                            <Typography>
                                                <Link
                                                    component="button"
                                                    onClick={() => handleShowSelectedCV(detailsCv.iduser)}
                                                    underline="hover"
                                                    sx={{ cursor: 'pointer' }} 
                                                >
                                                    PJ
                                                </Link>
                                            </Typography>
                                        </Grid>
                                    </>
                                ) : (
                                    <Grid item xs={12} className={classes.gridItem}>
                                        <Typography> Votre CV est encore incomplet</Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                        <div style={{ width: '100%', overflow: 'visible' }}>
                            <Grid item xs={12} className={classes.userAccordionFooter}>                  
                                <Typography variant={isMobile ? "body2" : "body1"}> 
                                    Veuillez suivre ce <Link underline="hover" href={`${process.env.REACT_APP_URL_MAJ_CV_USER}${localStorage.getItem('USER')}`} target="_blank" rel="noopener noreferrer">lien</Link> pour mettre à jour votre CV.
                                </Typography>
                            </Grid>
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
}